import { colorAttentionBlue50 } from "@rhumbix/rmbx_design_system_web"
import { css } from "styled-components"

export const zIndex = {
    SideRail: 5,
}

// Just in case you need just the transition specs for the glowy blue border.
export const activeInputTransitionStyles = css`
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
`

// Used to style a border provided by a container element that wraps an input element.
// An example of this is AutocompleteInput.
export const activeInnerInputStyles = css`
    border-color: ${colorAttentionBlue50};
    box-shadow: 0 0 2px 1.5px color-mix(in srgb, ${colorAttentionBlue50} 30%, transparent);
`

// Style an interactable form element like an input or select field with a glowy blue border.
export const activeInputStyles = css`
    ${activeInputTransitionStyles}

    &:focus,
    &:active {
        ${activeInnerInputStyles}
        outline: none;
    }
`
